import CreatorDashboardScreen from '@/features/unified-learning/creator/screens/CreatorDashboardScreen';

export default CreatorDashboardScreen;
